/**
 * The server-side Candidate Search flag (no imports: read by featureFlagsRepo and the pages).
 * See src/lib/search/candidateSearchApi.ts and functions/src/candidateSearch.ts.
 */
export const SERVER_CANDIDATE_SEARCH_FLAG = 'server_candidate_search';
export const SERVER_CANDIDATE_SEARCH_FLAG_LABEL = 'Candidate Search on the server';
export const SERVER_CANDIDATE_SEARCH_FLAG_DESCRIPTION =
  "Candidate Search, the dashboard's Top Matches and the checklist matches ask the server for one page of candidates (25, with Load more) instead of downloading every EMT profile. Same filters, same order, same demo rules. When 'on' for everyone, browsers can no longer list the whole profile collection (firestore.rules). Off: the old pages.";
